// Rotating placeholder questions shown in the Lumera Companion input.
export const PLACEHOLDER_QUESTIONS = {
  en: [
    'Why do I feel anxious?',
    'How do I forgive someone?',
    'What does God say about money?',
    'How do I find peace?',
    'I feel lost in life. What should I do?',
    'How do I deal with anger?',
    'Why does God feel far from me?',
    'How should I pray?',
    "What is God's purpose for my life?",
    'How do I overcome fear?',
    'Why am I going through this trial?',
    'How do I love difficult people?',
  ],
  es: [
    '¿Por qué me siento ansioso?',
    '¿Cómo perdono a alguien?',
    '¿Qué dice Dios sobre el dinero?',
    '¿Cómo encuentro paz?',
    'Me siento perdido en la vida. ¿Qué debo hacer?',
    '¿Cómo manejo el enojo?',
    '¿Por qué Dios se siente lejos de mí?',
    '¿Cómo debo orar?',
    '¿Cuál es el propósito de Dios para mi vida?',
    '¿Cómo supero el miedo?',
    '¿Por qué estoy pasando por esta prueba?',
    '¿Cómo amo a personas difíciles?',
  ],
};

// Empathetic one-tap prompts shown on the empty state.
export const EMOTION_STARTERS = {
  en: [
    { emoji: '😰', label: 'Anxious', prompt: "I'm feeling anxious today. What does the Bible say about anxiety?" },
    { emoji: '😔', label: 'Sad', prompt: 'I feel sad and alone. How does God comfort me?' },
    { emoji: '😤', label: 'Angry', prompt: "I'm struggling with anger. What does the Word say?" },
    { emoji: '🙏', label: 'Grateful', prompt: 'I want to grow in gratitude. Guide me with Scripture.' },
    { emoji: '🤔', label: 'Confused', prompt: "I feel lost and need God's direction." },
    { emoji: '😨', label: 'Fearful', prompt: "I'm afraid of what's coming. How do I trust God?" },
    { emoji: '💔', label: 'Broken', prompt: 'My heart is broken. Where is God in my pain?' },
    { emoji: '✨', label: 'Hopeful', prompt: 'I want to deepen my faith and hope in Christ.' },
  ],
  es: [
    { emoji: '😰', label: 'Ansioso', prompt: 'Me siento ansioso hoy. ¿Qué dice la Biblia sobre la ansiedad?' },
    { emoji: '😔', label: 'Triste', prompt: 'Me siento triste y solo. ¿Cómo me consuela Dios?' },
    { emoji: '😤', label: 'Enojado', prompt: 'Estoy luchando con el enojo. ¿Qué dice la Palabra?' },
    { emoji: '🙏', label: 'Agradecido', prompt: 'Quiero crecer en gratitud. Guíame con la Escritura.' },
    { emoji: '🤔', label: 'Confundido', prompt: 'Me siento perdido y necesito dirección de Dios.' },
    { emoji: '😨', label: 'Con miedo', prompt: 'Tengo miedo de lo que viene. ¿Cómo confío en Dios?' },
    { emoji: '💔', label: 'Quebrantado', prompt: 'Mi corazón está roto. ¿Dónde está Dios en mi dolor?' },
    { emoji: '✨', label: 'Esperanzado', prompt: 'Quiero profundizar mi fe y esperanza en Cristo.' },
  ],
};

// Voice navigation keyword map (lowercased keyword → route).
export const NAV_MAP = {
  bible: '/bible',
  biblia: '/bible',
  reader: '/bible',
  lector: '/bible',
  bookmark: '/bookmarks',
  marcadores: '/bookmarks',
  notes: '/notes',
  notas: '/notes',
  profile: '/profile',
  perfil: '/profile',
  dashboard: '/dashboard',
  panel: '/dashboard',
  maps: '/maps',
  mapas: '/maps',
  'reading plan': '/reading-plans',
  'plan de lectura': '/reading-plans',
};
